export const DURATION_OF_THE_EVENT = {
    ALL_DAY: 2,
  };